import React from 'react'
import SectionHeader from './SectionHeader';
import { format } from 'date-fns'
import { ClipboardList } from 'lucide-react';
type OrderDataProps = {
  order: {
    orderID: string;
    orderDate: string;
    ResinSampleModel: boolean;
    Size: string;
    TypeofJewelry: string;
    MetalType: string;
    DesignType?: string | null;
    DiamondQuality?: string | null;
    Quantity: number;
    labels?: string[];
    businessName?: string;
  },
  isAdmin: boolean | null
}

function OrderDetails({ order, isAdmin }: OrderDataProps) {
  const rows: [string, React.ReactNode][] = [
    ['Order ID', order.orderID],
    ['Date of Creation', order.orderDate ? format(new Date(order.orderDate), 'MMM dd, yyyy') : ''],
    ...(isAdmin ? [['Business Name', order.businessName] as [string, React.ReactNode]] : []),
    ['Type of Jewelry', order.TypeofJewelry],
    ['Size', order.Size],
    ['Metal Type', order.MetalType],
    ['Order Type', order.DesignType],
    ['Stone Type', order.DiamondQuality],
    ['Quantity', order.Quantity],
    ['Resin Sample Model', order.ResinSampleModel ? 'Provide' : 'None'],
  ]

  return (
    <div className='flex flex-col bg-white border border-[#E9EAEB] rounded-md text-caption1 overflow-hidden'>
      <SectionHeader
        title='Order Details'
        sectionIcon={<ClipboardList strokeWidth={1.5} className="w-5 h-5 text-gray-600" />}
        isAdmin={isAdmin}
      />
      <div className='p-4 md:p-4'>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-x-8'>
          {rows.map(([label, value], i) => (
            <div key={label} className={`flex justify-between md:grid md:grid-cols-2 items-center md:items-start gap-2 border-b pb-2 md:border-0 md:pb-0 ${i === rows.length - 1 ? 'border-transparent' : 'border-gray-100'}`}>
              <span className='text-gray-500 font-medium'>{label}:</span>
              <span className='font-semibold text-gray-900 break-words text-right md:text-left'>{value || '-'}</span>
            </div>
          ))}

          {/* Labels Row */}
          <div className='flex gap-6 items-center md:items-start gap-2 border-t border-gray-100 pt-4 mt-2 md:col-span-2 col-span-1'>
            <span className='text-gray-500 font-medium'>Labels:</span>
            <div className='flex flex-wrap gap-1.5 text-right md:text-left md:justify-start justify-end'>
              {order.labels && order.labels.length > 0 ? (
                order.labels.map((label, index) => (
                  <span
                    key={index}
                    className='px-2 py-0.5 text-xs font-normal rounded-md bg-[#883734]/10 text-[#883734] border border-[#883734]/20'
                  >
                    {label}
                  </span>
                ))
              ) : (
                <span className='text-gray-400 italic'>No labels</span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OrderDetails